export default {"src":"/_next/static/media/googleplay.74ec47c1.svg","height":78,"width":230,"blurWidth":0,"blurHeight":0};